import { DataExtractionResult, TServerErrorResponse } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";
import { AxiosError } from "axios";

export const DATA_EXTRACTION_STATUS_GET = "data-extraction-status-get";

export const getDataExtractionStatus = async (
  conversationId: string,
): Promise<DataExtractionResult | null> => {
  if (!conversationId) return null;
  try {
    const response = await http.get<DataExtractionResult>(
      links.dataExtraction.statusByConversationId(conversationId),
    );

    return response.data;
  } catch (error) {
    // Return null if not found (404) - status not yet created
    const axiosError = error as AxiosError;
    if (axiosError?.response?.status === 404) {
      return null;
    }
    throw error as TServerErrorResponse;
  }
};
